import { useQuery } from '@tanstack/react-query';
import {
  fetchFundDetails,
  fetchCompanyFunds,
  getQueryStrategy,
  CompanyFundsQueryResult,
  FundDetailsResult,
} from './companyFundsQueries';

interface Params {
  fundId: string;
  companyId: string;
  companyName: string;
  companyWebsiteUrl: string;
  currentPage: number;
  rowsPerPage: number;
}

export function useCompanyFundsQueries({
  fundId,
  companyId,
  companyName,
  companyWebsiteUrl,
  currentPage,
  rowsPerPage,
}: Params) {
  const fundDetailsQuery = useQuery<FundDetailsResult, Error>({
    queryKey: ['fundDetails', fundId],
    queryFn: () => fetchFundDetails(fundId),
    enabled: !!fundId,
    staleTime: 5 * 60 * 1000,
  });

  const companyFundsQuery = useQuery<CompanyFundsQueryResult, Error>({
    queryKey: [
      'companyFunds',
      companyId || 'null',
      fundId,
      currentPage,
      rowsPerPage,
      companyName || 'null',
      companyWebsiteUrl || 'null',
      getQueryStrategy(),
    ],
    queryFn: () =>
      fetchCompanyFunds({
        company_id: companyId,
        excludeFundId: fundId,
        page: currentPage,
        pageSize: rowsPerPage,
        companyName,
        websiteUrl: companyWebsiteUrl,
      }),
    enabled: !!fundId && (!!companyId || !!companyName || !!companyWebsiteUrl),
    placeholderData: (previousData) => previousData,
  });

  return { fundDetailsQuery, companyFundsQuery };
}
